import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useQueryParams from './useQueryParams';
import { useAppDispatch } from 'store/hooks';
import { washHub } from 'store/slices';

type UrlParams = Record<string, string>;

function useUrlSharing(urlObj: UrlParams = {}, washHubId?: string): boolean {
  const [redayToRender, setRedayToRender] = useState(false);

  const queryUrl = useQueryParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const washHubIdFromUrl = queryUrl.washHubId;
  const allWashHubs = washHub.selectors.useAllWashHubs();

  useEffect(() => {
    const url = `${location.pathname}?${new URLSearchParams(
      urlObj,
    ).toString()}`;

    navigate(url);
  }, [urlObj]);

  useEffect(() => {
    // if diffrent washub in url then set it to store
    if (washHubId && washHubIdFromUrl && washHubId !== washHubIdFromUrl) {
      const _selectedWashHub = allWashHubs?.find(
        (w) => w._id === washHubIdFromUrl,
      );
      _selectedWashHub &&
        dispatch(washHub.WashhubActions.setSelectedLocation(_selectedWashHub));
    }
    setRedayToRender(true);
  }, []);

  return redayToRender;
}

export default useUrlSharing;
